module.exports = __webpack_public_path__ + "img/c_5.0dc0b264.png";